import { TabUnderline } from "@/design-system/Tabs/CategoryTab";
import { cn } from "@/lib/utils";
import { canUseClubImportSelector } from "@/redux/user/userSlice";
import { useTranslation } from "@repo/shared/i18n";
import { useSelector } from "react-redux";
import { NavLink } from "react-router";

type ActiveTab = "overview" | "players" | "builder" | "my-evolutions";

interface EvolutionsMobileNavProps {
  active: ActiveTab;
}

export const EvolutionsMobileNav = ({ active }: EvolutionsMobileNavProps) => {
  const { t } = useTranslation("evolutions");
  const items: { label: string; tab: ActiveTab; to: string }[] = [
    {
      label: t("mobileNav.overview"),
      tab: "overview",
      to: "/evolutions/overview",
    },
    {
      label: t("mobileNav.players"),
      tab: "players",
      to: "/evolutions/players",
    },
    {
      label: t("mobileNav.builder"),
      tab: "builder",
      to: "/evolutions/builder",
    },
    {
      label: t("mobileNav.myEvos"),
      tab: "my-evolutions",
      to: "/evolutions/my-evolutions",
    },
  ];

  // The SBC category tabs' look: faint words, the active one white over a
  // primary underline.
  return (
    <nav className="mb-3 flex w-full justify-around border-b border-edge-strong bg-background px-2 mobile:hidden">
      {items.map(({ label, tab, to }) => {
        const isActive = active === tab;
        return (
          <NavLink
            key={tab}
            to={to}
            className={cn(
              "relative px-2 py-3 text-sm font-medium whitespace-nowrap transition-colors",
              isActive
                ? "text-foreground"
                : "text-foreground-faint hover:text-foreground-body",
            )}
          >
            {label}
            {isActive && <TabUnderline className="-bottom-px" />}
          </NavLink>
        );
      })}
    </nav>
  );
};
